"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AccordionContext_1 = __importDefault(require("../../contexts/AccordionContext"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const Accordion = (props) => {
    const { children, title, openByDefault = false, onOpen, onClose, isOpen, onChange } = props;
    const [open, setOpen] = react_1.useState(openByDefault);
    const contextValue = react_1.useMemo(() => ({
        open: isOpen !== null && isOpen !== void 0 ? isOpen : open,
        title,
        onOpen,
        onChange,
        onClose,
        openByDefault,
        setOpen,
    }), [isOpen, open, title, onOpen, onChange, onClose, openByDefault]);
    return (react_1.default.createElement(AccordionContext_1.default.Provider, { value: contextValue },
        react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props)), children)));
};
exports.default = withJourney_1.default('j-accordion', Accordion);
